(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-template-v2"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {

  const items = document.querySelectorAll(".about-gallery-item");
  const textBox = document.getElementById("about-hover-text");

  if (!textBox) return;


  items.forEach(function(item) {

    item.addEventListener("mouseenter", function() {

      const description = this.getAttribute("data-desc");

      if (description) {
        textBox.innerHTML = description;
      }

    });


    /* Mobile support */
    item.addEventListener("click", function() {

      const description = this.getAttribute("data-desc");

      if (description) {
        textBox.innerHTML = description;
      }

    });

  });

});


  } catch(e) { console.error(e); }
})();
})();
